// FILE: /src/Components/ConnectProfileModal.js (FULLY UPDATED)

import React, { useState, useEffect } from 'react';
import { Modal, Button, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { useSocialConnect } from '../hooks/useSocialConnect';

const platforms = [
{ name: "Facebook", key: 'FACEBOOK', icon: 'Facebook.png' },
{ name: "Instagram", key: 'INSTAGRAM', icon: 'Instagram.png' },
{ name: "Pinterest", key: 'PINTEREST', icon: 'Pintrest.png' },
{ name: "LinkedIn", key: 'LINKEDIN', icon: 'LinkedIn.png', hasChoice: true }, // Add a flag
{ name: "Google Business", key: 'GMB', icon: 'GB.png', comingSoon: true },
{ name: "YouTube", key: 'YOUTUBE', icon: 'Youtube.png', comingSoon: false },
{ name: "X (Twitter)", key: 'TWITTER', icon: 'Twitter.png', comingSoon: true },
{ name: "TikTok", key: 'TIKTOK', icon: 'Tiktok.png', comingSoon: false },
];

const PlatformIcon = ({ iconName, platformName }) => {
const [iconSrc, setIconSrc] = useState(null);
useEffect(() => {
try {
const src = require(`../Assets/Icons/${iconName}`);
setIconSrc(src);
} catch (error) {
console.warn(`Icon for ${platformName} (${iconName}) not found.`);
setIconSrc(null);
}
}, [iconName, platformName]);

if (iconSrc) {
return <img src={iconSrc} alt={platformName} className="w-8 h-8" />;
}
return (
<div className="w-8 h-8 flex items-center justify-center bg-gray-200 rounded-md">
<i className="fa-solid fa-link text-gray-500"></i>
</div>
);
};

const ConnectProfileModal = ({ isOpen, onClose }) => {
const { selectedGroup } = useSelector((state) => state.groups);
const { connect, UpgradePrompt } = useSocialConnect();
const [connectingPlatform, setConnectingPlatform] = useState(null);
const [linkedInStep, setLinkedInStep] = useState('initial'); // 'initial' or 'choice'

const handleConnectClick = async (platformKey, groupName, hasChoice) => {
if (hasChoice) {
setLinkedInStep('choice');
return;
}
setConnectingPlatform(platformKey);
await connect(platformKey, groupName);
// Reset connecting platform state after the promise resolves or rejects
setConnectingPlatform(null);
};

const handleClose = () => {
setLinkedInStep('initial'); // Reset on close
onClose();
};

const renderInitialView = () => (
<div>
<h3 className="text-xl font-semibold mb-2">Connect a Social Profile</h3>
<p className="text-gray-500 mb-6">Select a network to connect a profile to the "{selectedGroup}" brand.</p>
<div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
<div>
<h4 className="font-semibold text-gray-700 mb-3">Available Connections</h4>
<div className="space-y-3">
{platforms.filter(p => !p.comingSoon).map(p => (
<div key={p.key} className="p-3 border rounded-lg flex items-center justify-between">
<div className="flex items-center gap-3">
<PlatformIcon iconName={p.icon} platformName={p.name} />
<span className="font-medium">{p.name}</span>
</div>
<Button
onClick={() => handleConnectClick(p.key, selectedGroup, p.hasChoice)}
loading={connectingPlatform === p.key}
disabled={!!connectingPlatform}
>
Connect
</Button>
</div>
))}
</div>
</div>
<div>
<h4 className="font-semibold text-gray-700 mb-3">Coming Soon</h4>
<div className="space-y-3">
{platforms.filter(p => p.comingSoon).map(p => (
<div key={p.key} className="p-3 border rounded-lg flex items-center justify-between bg-gray-50 opacity-60">
<div className="flex items-center gap-3">
<PlatformIcon iconName={p.icon} platformName={p.name} />
<span className="font-medium text-gray-500">{p.name}</span>
</div>
<Button disabled>
Coming Soon
</Button>
</div>
))}
</div>
</div>
</div>
</div>
);

const renderLinkedInChoiceView = () => (
<div>
    <button onClick={() => setLinkedInStep('initial')} className="text-sm text-gray-500 hover:text-gray-800 mb-4">
        <i className="fa fa-arrow-left mr-2"></i>Back to all platforms
    </button>
    <h3 className="text-xl font-semibold mb-2">Connect a LinkedIn Profile</h3>
    <p className="text-gray-500 mb-6">Which type of LinkedIn profile would you like to connect?</p>
    <div className="space-y-4">
        <button onClick={() => handleConnectClick('LINKEDIN', selectedGroup)} className="w-full p-4 border rounded-lg flex items-center gap-4 text-left hover:bg-gray-50 transition-colors">
            <i className="fa-solid fa-user text-3xl text-blue-700 w-8 text-center"></i>
            <div>
                <p className="font-semibold">Personal Profile</p>
                <p className="text-sm text-gray-500">Connect your individual LinkedIn account.</p>
            </div>
        </button>
        {/* --- START: THIS IS THE FIX --- */}
        <button 
            disabled
            className="w-full p-4 border rounded-lg flex items-center gap-4 text-left transition-colors opacity-50 cursor-not-allowed"
        >
            <i className="fa-solid fa-building text-3xl text-gray-400 w-8 text-center"></i>
            <div>
                <div className="flex items-center gap-2">
                    <p className="font-semibold text-gray-500">Company Page</p>
                    <span className="text-xs font-bold text-yellow-800 bg-yellow-200 px-2 py-0.5 rounded-full">Coming Soon</span>
                </div>
                <p className="text-sm text-gray-400">Connect a LinkedIn page you manage.</p>
            </div>
        </button>
        {/* --- END: THIS IS THE FIX --- */}
    </div>
</div>
);

return (
<>
<Modal
open={isOpen}
onCancel={handleClose}
width={700}
footer={null}
destroyOnClose
>
{connectingPlatform ? (
<div className="text-center p-12">
<Spin size="large" />
<p className="mt-4 text-gray-600">Preparing to connect with {connectingPlatform.replace('_BUSINESS', '')}...</p>
</div>
) : (
linkedInStep === 'choice' ? renderLinkedInChoiceView() : renderInitialView()
)}
</Modal>
<UpgradePrompt />
</>
);
};

export default ConnectProfileModal;